import pauseIconPressed from '../../../images/player/media-pause-pressed.png';
import pauseIcon from '../../../images/player/media-pause.png';
import playIconDisabled from '../../../images/player/media-play-disabled.png';
import playIconPressed from '../../../images/player/media-play-pressed.png';
import playIcon from '../../../images/player/media-play.png';
import { DocumentType, SummaryDocument } from '../../../types/Podcast';
import { getDuration, getProgress } from '../../../utils/utils';

export const isDocumentPlaying = (
  playerDocument: DocumentType | '',
  document: DocumentType,
  isPaused: boolean
): boolean => {
  if (!playerDocument || isPaused) return false;

  return playerDocument.url === document.url;
};

export const isSummaryDocumentPlaying = (
  playerDocument: DocumentType | '',
  summaryDocument: SummaryDocument | null,
  isPaused: boolean
): boolean => {
  if (!playerDocument || isPaused) return false;

  return (
    playerDocument?.id === summaryDocument?.id ||
    playerDocument?.url === summaryDocument?.url
  );
};

export const getDocumentProgress = (
  playerDocument: DocumentType | '',
  document: DocumentType
): number => {
  return playerDocument !== '' && playerDocument.id === document.id
    ? getProgress(playerDocument.progress, getDuration(playerDocument.duration))
    : getProgress(document.progress, getDuration(document.duration));
};

export const getSummaryDocumentProgress = (
  playerDocument: DocumentType | '',
  summaryDocument: SummaryDocument | null
): number => {
  return summaryDocument !== undefined &&
    playerDocument !== '' &&
    playerDocument.id === summaryDocument?.id
    ? getProgress(playerDocument.progress, getDuration(playerDocument.duration))
    : getProgress(
        summaryDocument?.progress || 0,
        getDuration(summaryDocument?.duration || 0)
      );
};

export const getIconSource = (
  disabled: boolean,
  isPlaying: boolean,
  isPressed: boolean
): string => {
  if (disabled) {
    return playIconDisabled;
  }

  if (isPlaying) {
    return isPressed ? pauseIconPressed : pauseIcon;
  }

  return isPressed ? playIconPressed : playIcon;
};
// File renamed to src/features/documents/utils/utils.ts
